import {
  HvacArea,
  HvacGroup,
  ProjectHvac,
  ProjectHvacAnswer,
  ProjectHvacArea,
  ProjectHvacGroup,
  ProjectHvacGroupArea,
  ProjectHvacSection,
  ProjectHvacVariant,
} from '@belimo-retrofit-portal/logic';
import { pipe } from 'fp-ts/function';
import * as A from 'fp-ts/ReadonlyArray';
import * as R from 'fp-ts/ReadonlyRecord';
import { HVAC_AREA_LIST } from 'src/modules/hvac/constants/area';
import { HVAC_GROUP_LIST } from 'src/modules/hvac/constants/group';
import {
  HvacFormAdditionalValue,
  HvacFormAssessmentData,
  HvacFormAreaData,
  HvacFormSectionAnswerData,
  HvacFormSectionData,
  HvacFormVariantData,
  HvacFormGroupData,
  HvacFormGroupAreaData,
} from 'src/modules/hvac/types/HvacFormData';

export function mapHvacFormToStore(form: HvacFormAssessmentData): ProjectHvac {
  return {
    comment: form.comment,
    prices: form.prices,
    areas: pipe(
      form.areas,
      R.map(mapHvacFormArea),
    ),
    groups: pipe(
      HVAC_GROUP_LIST,
      A.map((group) => form.groups[group].map((it) => mapHvacFormGroup(group, it))),
      A.flatten,
    ),
  };
}

function mapHvacFormArea(form: HvacFormAreaData): ProjectHvacArea {
  return {
    enabled: form.enabled,
    thermal: form.thermal,
    electrical: form.electrical,
  };
}

function mapHvacFormGroup(
  group: HvacGroup,
  form: HvacFormGroupData,
): ProjectHvacGroup {
  return {
    group: group,
    title: form.title,
    annotations: form.annotations,
    areas: pipe(
      HVAC_AREA_LIST,
      A.map((area) => mapHvacFormGroupArea(area, form.areas[area])),
    ),
  };
}

function mapHvacFormGroupArea(
  area: HvacArea,
  form: HvacFormGroupAreaData,
): ProjectHvacGroupArea {
  return {
    area: area,
    comment: form.comment,
    visible: form.visible,
    sections: form.sections.map(mapHvacFormSection),
  };
}

function mapHvacFormSection(form: HvacFormSectionData): ProjectHvacSection {
  return {
    id: form.config.id,
    enabled: form.enabled,
    answer: mapHvacFormSectionAnswer(form.answer),
  };
}

function mapHvacFormSectionAnswer(
  form: HvacFormSectionAnswerData,
): ProjectHvacAnswer {
  return {
    actual: mapHvacFormVariant(form.actual),
    future: mapHvacFormVariant(form.future),
  };
}

function mapHvacFormVariant(form: HvacFormVariantData): ProjectHvacVariant {
  return {
    option: form.option?.id ?? null,
    additionals: form.additionals.reduce<Record<string, HvacFormAdditionalValue>>((map, it) => {
      // eslint-disable-next-line no-param-reassign
      map[it.config.id] = it.value;
      return map;
    }, {}),
  };
}
